var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0217 33.6924V46.5017L0 59.5177V42.473L26.0217 33.6924Z",
    fill: "#89664C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1387 33.6924H67V46.3984H26.1387V33.6924Z",
    fill: "#B77E58"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0217 46.5391L0 59.555H55.91L66.883 46.5391H26.0217Z",
    fill: "#F2BC97"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.92314 34.0668L22.7688 21.7223L13.1652 4.35408C12.4703 4.95019 11.9094 5.79949 11.6627 6.85111L4.8343 31.2549C4.58762 32.3065 4.61723 33.2438 4.92314 34.0668ZM62.3242 9.03694L36.8267 24.5947L51.3242 48.9115C52.4525 48.3023 53.3014 47.2626 53.6788 45.9195L62.8993 12.621C63.2767 11.2779 62.9676 9.91023 62.3242 9.03694Z",
    fill: "#B0BDC6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3295 30.1156L22.9206 21.6844L5.07492 34.029C5.30805 34.7634 5.82907 35.3075 6.48082 35.5601L48.2268 49.2446C49.3732 49.6487 50.528 49.4321 51.476 48.8737L36.9785 24.5569L27.3295 30.1156Z",
    fill: "#CAD5DD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7348 7.48282L15.2889 3.58008C14.518 3.54294 13.8695 3.83499 13.2705 4.36766L22.9584 21.7484L27.3674 30.1796L37.0163 24.6208L62.4294 9.05052C61.7861 8.17722 60.8432 7.57026 59.7348 7.48282Z",
    fill: "#DFE9EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9947 42.4727C36.9947 42.4727 36.6812 49.7037 35.2181 51.0467C32.3965 53.7325 23.6181 53.7325 20.6919 51.0467C19.2289 49.7037 18.9154 42.4727 18.9154 42.4727H0V59.5174H55.91V42.4727H36.9947Z",
    fill: "#D3976E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8851 46.5008L55.9121 59.5167V42.472L66.8851 33.6914V46.5008Z",
    fill: "#89664C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmails);
export default __webpack_public_path__ + "static/media/emails.a46cbd2db49c9b276e8ea158383dc0bf.svg";
export { ForwardRef as ReactComponent };